import React from "react";

interface TabOption {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: TabOption[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = "",
}) => {
  return (
    <div
      className={`d-flex justify-content-start border-bottom ${className}`}
      style={{ borderBottomWidth: "1px" }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          id={`tab-${tab.id}`}
          data-testid={`tab-${tab.id}`}
          className={`tab-btn text-decoration-none text-secondary px-4 py-2 border-0  ${
            activeTab === tab.id
              ? "text-dark border-bottom border-1 border-dark"
              : "text-muted"
          }`}
          style={{
            backgroundColor: "transparent",
            borderRadius: 0,
            fontSize: "16px",
          }}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
